import axios from 'axios'; // used for interacting with the backend API
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../Mantle Logo.png';

// Public backend URL, pulled from runtime config (public/config.js) so it can
// be set per deployment without rebuilding. Falls back to localhost for dev.
//
// The `typeof window` guard is for the build-time prerender (scripts/prerender.js),
// which evaluates this module in Node where there is no window. App.js routes
// /license here, so the module IS pulled into the prerender bundle even though
// no prerendered route renders the page — and a module-scope `window` read runs
// the moment that bundle is require()d, taking the whole build down. Same guard,
// same reason, as pages/Domain.jsx.
const API_URL =
  (typeof window !== 'undefined' && window.MANTLE_CONFIG?.API_URL) ?? 'http://localhost:5000/api';

const LicenseGen = () => {
  const [domain, setDomain] = useState('');
  const [duration, setDuration] = useState(1);
  const [period, setPeriod] = useState('Y');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [modules, setModules] = useState('MOD_0_ADMIN, MOD_1_OPEX, MOD_5_CAPEX, MOD_7_VIEW, MOD_8_PEOPLE, MOD_10_REPORT');
  const [maxSites, setMaxSites] = useState(1);
  const [password, setPassword] = useState('');

  const checkDomain = (e) => {
    e.preventDefault();

    if (domain === null || domain === "") {
      setError('No Domain specified. Please specify a domain!');
      setSuccess('');
    } else {
      /* Ask the server to check for a tenant with the given tennant (domain) name, returning true/false match */
      axios.get(API_URL + '/users/check-domain/' + domain).then(response => {
        // Handle the retrieved data
        if (response.data?.matches && response.data?.url?.length > 0) {
          setError('');
          setSuccess('Matching domain found.');
        } else {
          setSuccess('');
          setError('Domain Not Found! Please type in a valid domain.');
        }
      }).catch(error => {
        // Handle any errors
        let msg = "An error occured while checking the domain: " + error.message;

        console.error(msg);
        setError(msg);
      });
    }
  };

  const genLicense = (e) => {
    e.preventDefault();

    let mods = modules.split(",");

    for (let i = 0; i < mods.length; i++) {
      mods[i] = mods[i].trim();
    }
    // calculate datetime of expiry
    let afternoon = new Date();
    afternoon.setHours(18, 0, 0, 0); // HH, MM, SS, Ms
    let expiryDate = afternoon;
    let numDays = 0;

    if (period === "Y") {
      numDays = (parseInt(duration, 10) * 365) + 1;
    } else {
      numDays = parseInt(duration, 10) * 31;
    }

    expiryDate.setDate(afternoon.getDate() + numDays); // handles month/year rollover

    // generate JSON
    let licObj = {
      domain: domain,
      expires: expiryDate,
      modules: mods,
      maxSites: maxSites,
      password: password
    };

    // encrypt the JSON (same as with security API endpoint, but without authentication). 
    axios.post(`${API_URL}/licenses/generate`, licObj).then((response) => {
      setSuccess("License code generated!");
      setError("");
      const respData = response.data;
      const alertMsg = "License string:\n" + (respData?.encrypted ?? "No license code returned!")
        + "\n Download the file from the backend server @ \"" + (respData?.fileName ?? "<Missing File Path!>")
        + "\".";

      alert(alertMsg);
    }).catch((error) => {
      console.error("License generation error", error);
      setError("License generation failed: " + error.message);
    }).finally(() => {
      console.log("License generation request completed.");
    });
  };

  const handlePeriodChange = (e) => {
    setPeriod(e?.target?.value || 'Y');
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f8fafc',
      fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e2e8f0'
      }}>
        {/* Branding */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img
            src={logo}
            alt="Mantle Logo"
            style={{ height: '32px', width: 'auto' }}
          />

          <p style={{ margin: '5px 0 0 0', color: '#64748b', fontSize: '0.9rem' }}>
            Please enter license details.
          </p>

        </div>

        <form onSubmit={genLicense} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Domain */}
          <div id="domain-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label htmlFor="domain" style={{ fontSize: '0.85rem', fontWeight: '600', color: '#475569' }}>Domain Name:</label>
            <input
              type="text"
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
              onBlur={(e) => checkDomain(e)}
              name="domain"
              id="domain"
              style={{
                padding: '10px 12px',
                borderRadius: '4px',
                border: '1px solid #cbd5e1',
                fontSize: '1rem',
                outline: 'none'
              }}
              placeholder="Eg: Mantle_Budget"
              autoFocus="true"
            />
          </div>
          <p style={{ fontSize: '0.9rem' }}>Expiry</p>
          <div id="expiry-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label htmlFor="duration" style={{ fontSize: '0.85rem', fontWeight: '600', color: '#475569' }}>Duration:</label>
            <input
              type="number"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              name="duration"
              id="duration"
              min="1"
              max="5"
              style={{
                padding: '10px 12px',
                borderRadius: '4px',
                border: '1px solid #cbd5e1',
                fontSize: '1rem',
                outline: 'none'
              }}
            />
            <label htmlFor="period-month" style={{ fontSize: '0.85rem', fontWeight: '600', color: '#475569' }}>
              <input
                type="radio"
                value="M"
                onChange={(e) => handlePeriodChange(e)}
                checked={period === 'M'}
                name="period"
                id="period-month"
                style={{
                  padding: '10px 12px',
                  borderRadius: '4px',
                  border: '1px solid #cbd5e1',
                  fontSize: '1rem',
                  outline: 'none'
                }}
              />
              Month(s)</label>
            <label htmlFor="period-year" style={{ fontSize: '0.85rem', fontWeight: '600', color: '#475569' }}>
              <input
                type="radio"
                value="Y"
                onChange={(e) => handlePeriodChange(e)}
                checked={period === 'Y'}
                name="period"
                id="period-year"
                style={{
                  padding: '10px 12px',
                  borderRadius: '4px',
                  border: '1px solid #cbd5e1',
                  fontSize: '1rem',
                  outline: 'none'
                }}
              />
              Year(s)</label>
          </div>
          {/* Modules */}
          <div id="modules-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label htmlFor="modules" style={{ fontSize: '0.85rem', fontWeight: '600', color: '#475569' }}>Modules:</label>
            <input
              type="text"
              value={modules}
              onChange={(e) => setModules(e.target.value)}
              name="modules"
              id="modules"
              style={{
                padding: '10px 12px',
                borderRadius: '4px',
                border: '1px solid #cbd5e1',
                fontSize: '1rem',
                outline: 'none'
              }}
              placeholder="Eg: MOD_0_ADMIN, MOD_1_OPEX, MOD_5_CAPEX"
            />
          </div>
          {/* Maximum site count */}
          <div id="max-sites-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label htmlFor="maxSites" style={{ fontSize: '0.85rem', fontWeight: '600', color: '#475569' }}>Maximum Site Count:</label>
            <input
              type="number"
              value={maxSites}
              onChange={(e) => setMaxSites(e.target.value)}
              name="maxSites"
              id="maxSites"
              min="1"
              max="100"
              style={{
                padding: '10px 12px',
                borderRadius: '4px',
                border: '1px solid #cbd5e1',
                fontSize: '1rem',
                outline: 'none'
              }}
              placeholder="Eg: Mantle_Budget"
            />
          </div>
          <div id="password-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label htmlFor="password" style={{ fontSize: '0.85rem', fontWeight: '600', color: '#475569' }}>Authentication Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              name="password"
              id="password"
              style={{
                padding: '10px 12px',
                borderRadius: '4px',
                border: '1px solid #cbd5e1',
                fontSize: '1rem',
                outline: 'none'
              }}
              placeholder="Enter the authentication password here."
            />
          </div>
          {/* Error Message */}
          {error && (
            <div id="error-wrapper" style={{ color: '#cc0000', fontSize: '0.85rem', textAlign: 'center' }}>
              {error}
            </div>
          )}

          {/* Success Message */}
          {success && (
            <div id="success-wrapper" style={{ color: '#00cc00', fontSize: '0.85rem', textAlign: 'center' }}>
              {success}
            </div>
          )}

          {/* Generation Button */}
          <button
            type="submit"
            style={{
              marginTop: '10px',
              padding: '12px',
              backgroundColor: '#0f172a',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1e293b'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#0f172a'}
            onClick={(e) => genLicense(e)}
          >
            Generate License
          </button>
        </form>

        {/* Back to the public marketing site */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Link to="/" style={{ color: '#64748b', fontSize: '0.85rem', textDecoration: 'none' }}>
            &larr; Back to mantlebudget.com
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LicenseGen;
